// GENERATED by scripts/build-icons.mjs from icons/plus.svg — do not edit.
// Lucide (ISC); Feather-derived icons additionally MIT. See LICENSE-lucide.
import { createIcon } from '../createIcon'

export const Plus = createIcon('plus', [
  ['path', { d: "M5 12h14" }],
  ['path', { d: "M12 5v14" }],
])
